<script>
  import SectionRenderer from '../components/SectionRenderer.vue';
  import sections from './sections.json';
  import HashChangeListenerMixin from '@/views/app/dashboard/footer-pages/components/HashChangeListenerMixin';

  export default {
    name: 'PrivacyPolicy',
    components: { SectionRenderer },
    mixins: [HashChangeListenerMixin(sections, sections[0].children)],
    data: () => ({
      isScrolling: false,
    }),
    metaInfo() {
      return {
        title: 'Privacy Policy',
        meta: [
          {
            name: 'robots',
            content: 'noindex, nofollow',
          },
        ],
      };
    },
  };
</script>
<template>
  <div class="page-container">
    <div class="page">
      <!--      <Quicklinks :sections="allSections" />-->
      <div class="content">
        <h1 class="mb-8">PRIVACY POLICY</h1>
        <span class="white--text mb-4 d-block">Version: 1.0 | Last updated: June 17, 2024.</span>
        <h2 class="mt-10 mb-6">MaxQuest Statement</h2>
        <p>
          This privacy policy (“Policy”) governs how MQ Technology DWC-LLC (operating under “MaxQuest” and
          “maxquest.com”) and its applicable affiliates and subsidiaries (collectively, “MaxQuest”, “we,” “our” or “us”)
          collect, use, protect and share personal information we collect or receive in connection with your access and
          use of:
        </p>
        <p>
          (1) MaxQuest-operated gaming websites and mobile gaming applications, including all features, functionalities,
          applications, browser extensions, and other services available through them (collectively, our United States
          “Gaming Operations”); and (2) other websites that we operate, including, without limitation, our corporate
          website, located at www.maxquest.com, and other websites or mobile applications we operate that provide a link
          directly to this Policy, including all features, functionalities, applications, browser, and extensions and
          other services available through them (collectively, our “Corporate Websites” and, together with our Gaming
          Operations, our “Online Offerings”).
        </p>
        <p>
          This Policy also applies to any personal information we collect or receive in connection with any other
          interactions we have with you outside of our Online Offerings related to our business operations, such as when
          you contact us or use other services we provide (collectively, together with our Online Offerings, our
          “Services”)., This Policy does not apply to our practices regarding the collection, use, storage, disclosure,
          and protection of personal data related to our employees and job applicants.
        </p>
        <p>
          You can access our Online Offerings in many ways, including from a computer or mobile device, and this Policy
          will apply regardless of the means of access. To the extent we provide you notice through our Online Offerings
          of different or additional privacy policies or practices (e.g., at the point of collection), those additional
          terms shall govern such data collection and use in addition to this Policy.
        </p>
        <p>
          Please read this Policy carefully. If you do not want us to collect, use, or disclose your personal
          information in the ways described in this Policy, please do not use our Services, provide us with your
          personal information, or authorize a third party to make your personal information available to us. By using
          our Services, providing us with your personal information, or otherwise making your personal information
          available to us, you acknowledge that you understand that we may use your personal information as described in
          this Policy.
        </p>
        <p>
          Please note, as described in this Policy, we may receive your personal information from third parties who have
          not expressly advised you that they will disclose your personal information to us. If you have any questions
          about how we collect, use, protect, disclose, or otherwise process personal information, including whether we
          have received your personal information from a third party, please contact us via our Live Chat feature or by
          opening a ticket on our Discord Server.
        </p>
        <section-renderer
          class="mt-15"
          :sections="sections"
          @click="handleSectionClick"
          :active-section-index="activeSectionIndex"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import '../components/style.scss';

  ::v-deep .content {
    ol li:before {
      content: unset;
    }

    h2 {
      font-size: 40px !important;
    }

    .v-expansion-panel-content {
      ul {
        padding-left: 0;

        ul {
          padding-left: 16px;
        }

        &:not(.unstyled) span {
          display: block;
          position: relative;
          margin-left: 16px;

          &:before {
            content: '●';
            font-size: 10px;
            position: absolute;
            left: -16px;
            top: 5px;
            padding-left: 4px;
            margin-right: 8px;
          }
        }

        &.unstyled {
          li {
            margin-left: 16px;
          }
        }
      }

      ol {
        padding-left: 0;

        li {
          list-style-position: inside;

          p {
            padding-left: 16px;
          }

          ul {
            & > span {
              color: #fff;
            }

            li {
              color: rgba(#fff, 0.8);
              padding-left: 1em;
            }
          }
        }
      }
    }
  }
</style>
